import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { iBisAuthService, iBisResetPasswordComponent, iBisLoginComponent } from '@dohu/ibis-auth';
import { RoutesComponent } from './view/routes/routes.component';
import { LocationComponent } from './view/admin/location/location.component';
import { UserComponent } from './view/admin/user/user.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: iBisLoginComponent, data: [{ showRegister: true }] },
    { path: 'route', component: RoutesComponent, canActivate: [iBisAuthService] },
    {
        path: 'admin', children: [
            { path: 'users', component: UserComponent, canActivate: [iBisAuthService] },
            { path: 'location', component: LocationComponent, canActivate: [iBisAuthService] }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
    providers: [iBisAuthService],
    exports: [RouterModule]
})
export class AppRoutingModule { }